import { createContext } from 'react';
import { DependencyContainer, container } from 'tsyringe';

export const diContainerContext = createContext<DependencyContainer>(container);
